import * as React from "react";
import { TouchableOpacity} from "react-native";
import { useNavigation } from "@react-navigation/native";
import { AntDesign } from "@expo/vector-icons";

export default function Ellipsis({onClickFunction}) {
  const navigation = useNavigation();
  return (
    <TouchableOpacity
      onPress={onClickFunction}
    >
      <AntDesign name="ellipsis1" size={18} />
    </TouchableOpacity>
  );
}

